// assets/cart-upsell-apparel.js
(function () {
  // Helpers to find pieces of the carousel
  function block(el){ return el?.closest('.cm-apparel'); }
  function track(b){ return b?.querySelector('[data-track]'); }
  function slides(b){ return b ? Array.from(b.querySelectorAll('[data-slide]')) : []; }
  function viewport(b){ return b?.querySelector('.cm-apparel__carousel'); }

  // Move to a specific slide index (GPU-accelerated, fixed 100% slide width)
  function setIndex(b, i){
    const t = track(b), s = slides(b), vp = viewport(b);
    if (!t || !s.length || !vp) return;

    const idx = Math.max(0, Math.min(i, s.length - 1));
    t.dataset.index = String(idx);

    // Enforce each slide is exactly viewport width and clips its own content
    s.forEach(slide => { slide.style.flex = '0 0 100%'; });

    const w = vp.clientWidth;
    t.style.transform = `translate3d(${-idx * w}px, 0, 0)`; // smooth & GPU-accelerated

    // Prev/Next enabled state
    const prev = b.querySelector('[data-prev]'), next = b.querySelector('[data-next]');
    if (prev) prev.disabled = idx === 0;
    if (next) next.disabled = idx === s.length - 1;

    // Enable Add only if a variant is selected on the active slide
    const active = s[idx], sel = active?.querySelector('[data-variant]'), add = active?.querySelector('[data-add]');
    if (add) add.disabled = !(sel && sel.value);
  }

  function init(b){
    // Ensure fixed slide basis and alignment on first render
    slides(b).forEach(slide => { slide.style.flex = '0 0 100%'; });
    setIndex(b, 0);
  }

  // Keep slide aligned on viewport resize
  function realignAll(){
    document.querySelectorAll('.cm-apparel').forEach(b => {
      const t = track(b);
      if (!t) return;
      const idx = parseInt(t.dataset.index || '0', 10);
      setIndex(b, idx);
    });
  }
  window.addEventListener('resize', realignAll);

  // Drawer refresh that works with section_id or sections JSON
  async function refreshDrawer(){
    const bust = `ts=${Date.now()}`;
    let res = await fetch(`${location.pathname}?section_id=cart-drawer&${bust}`);
    let html = await res.text();

    if (!html || html.trim() === '') {
      res = await fetch(`${location.pathname}?sections=cart-drawer&${bust}`);
      html = await res.text();
    }

    let newDrawer = null;
    const asHtml = new DOMParser().parseFromString(html, 'text/html');
    newDrawer = asHtml.querySelector('cart-drawer');

    if (!newDrawer) {
      try {
        const json = JSON.parse(html);
        const wrap = document.createElement('div');
        wrap.innerHTML = json['cart-drawer'] || '';
        newDrawer = wrap.querySelector('cart-drawer');
      } catch {}
    }

    const current = document.querySelector('cart-drawer');
    if (current && newDrawer) {
      current.innerHTML = newDrawer.innerHTML;
      current.open?.();
      initAll(); // re-init carousel after redraw
    } else {
      location.reload();
    }
  }

  // Remove any currently-in-cart item whose handle is in the eligible list
  async function removeExistingEligible(b){
    try {
      const eligible = JSON.parse(b?.dataset.eligible || '[]');
      if (!eligible.length) return;

      const cart = await fetch('/cart.js', { headers:{Accept:'application/json'} }).then(r=>r.json());
      const updates = {};
      cart.items.forEach((it, i) => {
        if (eligible.includes(it.product_handle)) updates[i+1] = 0; // 1-based index
      });
      if (Object.keys(updates).length){
        await fetch('/cart/update.js', {
          method:'POST',
          headers:{'Content-Type':'application/json', Accept:'application/json'},
          body: JSON.stringify({ updates })
        });
      }
    } catch(e){ console.error('eligible parse error', e); }
  }

  async function addFromSlide(slide, b){
    const sel = slide.querySelector('[data-variant]');
    const variantId = sel && sel.value;
    if (!variantId) return;

    await removeExistingEligible(b);

    await fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json', Accept:'application/json'},
      body: JSON.stringify({ items: [{ id: String(variantId), quantity: 1 }] })
    });

    await refreshDrawer();
  }

  // Delegated events (survive drawer re-renders)
  document.addEventListener('click', async (e)=>{
    // Prev/Next
    const prev = e.target.closest('[data-prev]');
    const next = e.target.closest('[data-next]');
    if (prev || next){
      const b = block(prev || next), t = track(b);
      if (!t) return;
      const i = parseInt(t.dataset.index || '0', 10);
      setIndex(b, (prev ? i-1 : i+1));
    }

    // Add
    const add = e.target.closest('[data-add]');
    if (add){
      const b = block(add), slide = add.closest('[data-slide]');
      add.disabled = true;
      try { await addFromSlide(slide, b); }
      catch (err){ console.error(err); location.reload(); }
    }
  });

  document.addEventListener('change', (e)=>{
    if (e.target.matches('[data-variant]')){
      const s = e.target.closest('[data-slide]'), add = s?.querySelector('[data-add]');
      if (add) add.disabled = !(e.target.value);
    }
  });

  function initAll(){ document.querySelectorAll('.cm-apparel').forEach(init); }
  document.addEventListener('DOMContentLoaded', initAll);
  const mo = new MutationObserver(initAll);
  mo.observe(document.documentElement, { childList:true, subtree:true });
})();
